<div class="searchBarAteco mt-3">
    <div class="searchBarAteco__field">
        <div class="searchBarAteco__field__container d-flex justify-content-between align-items-center">
            <div>
                <i class="icon-search icon-search-bar ps-2"></i>
                <input [value]="this.searchValue" (keyup)="this.oneKeyUpInput($event, $event.target.value)"
                    autocomplete="off" type="text" class="input"
                    placeholder="Ricerca per nome, codice fiscale, partita IVA, ragione sociale">
            </div>
            <i [hidden]="this.searchValue === ''" (click)="this.searchValue = ''"
                class="icon-times cursor-pointer pe-2 pe-lg-0"></i>
        </div>
        <button (click)="this.handleAtecoSearch()"
            [disabled]="this.disableBtn || this.forbiddenError || this.currentUser?.atecoSearchCounter > 5"
            type="submit" class="btn btn-primary btn-primary__search py-2 px-3" name="button">Vedi risultati</button>
    </div>
</div>